import { PermissoesService } from './../service/usuario/permissoes.service';
import { Observable } from 'rxjs/Observable';
import { Directive, Input, OnInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appAccessControl]'
})
export class AccessControlDirective implements OnInit {

  @Input('moduleType') moduleType: string ;
  @Input('user') user: any;

  constructor(private elementRef: ElementRef, private permissionService: PermissoesService) { }

  grupos: any[];

  //userlogado: any[];

  ngOnInit( ) {
    this.elementRef.nativeElement.style.display = 'none';
    this.checkAccess();
  }

  checkAccess() {
    const userlogado: any = this.permissionService.getUserLogado();
    //this.grupos = accessControls.grupos;
    // const module: any = accessControls.find(access => console.log('access:' + access));
    // console.log('module: ' + module);
    this.elementRef.nativeElement.style.display = 'consumer' ? 'block' : 'none';
  }

}



// WEBPACK FOOTER //
// /app/src/app/directives/access-control.directive.ts